import compareAsc from 'date-fns/compareAsc'
import * as types from '../actions/actionTypes'

export const initialState = {
  logoURL: null,
  referral: null,
  vendorInfo: null,
}

export function logoURLSelector(vendor) {
  return vendor.logoURL
}

export function isCreateItemAvailable() {
  return compareAsc(new Date('2021/05/17'), new Date()) > 0
}

export function isPurchaseAvailable(vendor) {
  return (
    !!vendor.vendorInfo || compareAsc(new Date('2021/05/17'), new Date()) > 0
  )
}

export default function vendorReducer(vendor = initialState, action) {
  switch (action.type) {
    case types.GET_ITEM_ENTRY_INFO_SUCCESS:
    case types.GET_BUYER_INSTALMENTS_INFO_SUCCESS:
    case types.GET_BUYER_PERIODIC_INFO_SUCCESS:
      return {
        ...vendor,
        logoURL: action.payload.logo_url || null,
        referral: action.payload.referral,
        vendorInfo: action.payload.vendor,
      }
    case types.GET_ITEM_ENTRY_INFO_ERROR:
    case types.GET_BUYER_INSTALMENTS_INFO_ERROR:
      return initialState
    default:
      return vendor
  }
}
